import {useQuery} from "@tanstack/react-query";
import {api} from "@/data/api";
import {useRestaurant} from "@/context/restaurant/RestaurantProvider";
import {POS_ORDERS_REFRESH_INTERVAL} from "@/context/pos/PosProvider";

export const POS_ORDER_QUERY_KEY = "pos-order";

const usePosOrder = (publicCartId: string | undefined) => {
    const {dashboardLocation} = useRestaurant();

    return useQuery({
        queryKey: [POS_ORDER_QUERY_KEY, dashboardLocation.id, publicCartId],
        queryFn: () => api.orders.getOrder(dashboardLocation.id, publicCartId!),
        enabled: publicCartId !== undefined,
        staleTime: POS_ORDERS_REFRESH_INTERVAL,
        gcTime: 30 * 60_000,
    });
};

export default usePosOrder;